var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10492 25.6018C6.10492 26.1911 6.30292 26.6898 6.69892 27.0978C7.09492 27.5058 7.58992 27.7211 8.18392 27.7438H12.3419C12.9139 27.7438 13.4089 27.5285 13.8269 27.0978C14.2449 26.6671 14.4429 26.1685 14.4209 25.6018V8.43179C14.4209 7.84245 14.2229 7.33245 13.8269 6.90179C13.4309 6.47112 12.9359 6.26712 12.3419 6.28979H8.18392C7.61192 6.28979 7.11692 6.49379 6.69892 6.90179C6.28092 7.30979 6.08292 7.81979 6.10492 8.43179V25.6018ZM18.5789 25.6018C18.5789 26.1911 18.7879 26.6898 19.2059 27.0978C19.6239 27.5058 20.1079 27.7211 20.6579 27.7438H24.8159C25.3879 27.7438 25.8829 27.5285 26.3009 27.0978C26.7189 26.6671 26.9169 26.1685 26.8949 25.6018V8.43179C26.8949 7.84245 26.6969 7.33245 26.3009 6.90179C25.9049 6.47112 25.4099 6.26712 24.8159 6.28979H20.6579C20.0859 6.28979 19.6019 6.49379 19.2059 6.90179C18.8099 7.30979 18.6009 7.81979 18.5789 8.43179V25.6018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default __webpack_public_path__ + "static/media/icon-pause.285dd97e546e266014ec0f5ac7b37fcc.svg";
export { ForwardRef as ReactComponent };